import { Box, TooltipRenderer, Text, Button } from 'braid-design-system';
import React, { useState } from 'react';

import type {
  ClientListingForListingsTab,
  ListingProductForListingsTab,
} from 'src/types/graphql-derived';
import { BOOST_BUNDLE_DISCOUNT_FEATURE_TOGGLE_ENABLED } from 'src/utils/feature-flags';

import { BoostDialog } from './BoostDialog';
import { BoostDialogBundleDiscount } from './BoostDialogBundleDiscount';

interface BoostButtonProps {
  listing: ClientListingForListingsTab;
  isLus: boolean;
  // It's a lot cleaner implementation if we enforce both boosts are required
  searchBoostProduct: ListingProductForListingsTab;
  emailBoostProduct: ListingProductForListingsTab;
}

export const BoostButton = ({
  listing,
  isLus,
  searchBoostProduct,
  emailBoostProduct,
}: BoostButtonProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const isBoostBundleDiscountEligible =
    !listing.isPremium && !listing.isListingEmailBoosted;

  return (
    <Box>
      <Box display="flex" alignItems="flexEnd" height="full">
        <TooltipRenderer
          id="dashboard-actions-boosted-ad-prompt"
          tooltip={
            <Text>
              Purchase a Boost upgrade to reach more buyers and feature your ad
              at the top of search results.
            </Text>
          }
        >
          {({ triggerProps }) => (
            <Button {...triggerProps} onClick={() => setDialogOpen(true)}>
              Boost
            </Button>
          )}
        </TooltipRenderer>
      </Box>

      {BOOST_BUNDLE_DISCOUNT_FEATURE_TOGGLE_ENABLED &&
      isBoostBundleDiscountEligible ? (
        <BoostDialogBundleDiscount
          isOpen={dialogOpen}
          listing={listing}
          isLus={isLus}
          searchBoostProduct={searchBoostProduct}
          emailBoostProduct={emailBoostProduct}
          onClose={() => setDialogOpen(false)}
        />
      ) : (
        <BoostDialog
          isOpen={dialogOpen}
          listing={listing}
          searchBoostProduct={searchBoostProduct}
          emailBoostProduct={emailBoostProduct}
          onClose={() => setDialogOpen(false)}
        />
      )}
    </Box>
  );
};
